import React from 'react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';

export const FramedCard = ({ children, ...rest }: BoxProps) => (
  <Box
    as="article"
    display="flex"
    flexDirection="column"
    gap="4px"
    p="4px"
    borderRadius="xl"
    bg="surface.frame"
    boxShadow="frame"
    {...rest}
  >
    {children}
  </Box>
);

export const FramedCardContent = ({ children, ...rest }: BoxProps) => (
  <Box
    display="flex"
    flexDirection="column"
    flex="1"
    overflow="hidden"
    borderRadius="12px"
    bg="surface.base"
    boxShadow="card"
    {...rest}
  >
    {children}
  </Box>
);

export const FramedCardHeader = ({ children, ...rest }: BoxProps) => (
  <Box px="20px" py="12px" {...rest}>
    {children}
  </Box>
);

interface SectionCardProps extends BoxProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
}

export const SectionCard = ({
  title,
  description,
  action,
  children,
  ...rest
}: SectionCardProps) => (
  <Box bg="surface.base" borderRadius="xl" boxShadow="card" p="20px" {...rest}>
    {(title || action) && (
      <Flex align="flex-start" justify="space-between" gap="12px" mb={children ? '16px' : '0'}>
        <Box>
          {title && (
            <Text fontSize="16px" lineHeight="26px" fontWeight={500} color="content.strong">
              {title}
            </Text>
          )}
          {description && (
            <Text fontSize="13px" lineHeight="20px" color="content.body">
              {description}
            </Text>
          )}
        </Box>
        {action}
      </Flex>
    )}
    {children}
  </Box>
);
